  <template >
  <div>
  <div>
  <div class="formPosition">
    <v-card style="margin:auto;" width="1200" >
    <v-card-title style="background-color:#006699;color:white;"></v-card-title>
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading  "></v-progress-linear>

    <v-data-table    :headers="headers"  :items="comprovativos" :search="searchInDb"  sort-by="data_"   class="elevation-3" >
      <template v-slot:top>
        <v-toolbar flat color="white">

        <v-btn to="novo-comprovativo" style="background-color:#006699;color:white;" outlined> <v-icon md color="white darken-2">add</v-icon> Registrar Novo comprovativo </v-btn >

          <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title>Consultar comprovativos bancários</v-toolbar-title>
          <v-divider class="mx-8" inset vertical></v-divider>
          <!--  search  -->
          <div class="flex-grow-1"></div>
          <v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          <v-text-field
            v-model="searchInDb"
            append-icon="search"
            label="Pesquisa"
            single-line
            hide-details
          ></v-text-field>
          <!-- end  search  -->
        </v-toolbar>
      </template>
      <template v-slot:item.valor="{ item }">
        <span>{{utilitarios.IntegerToMoneyValueFatura(item.valor)}}</span>
      </template>
      <template v-slot:item.estado="{ item }">
        <span v-if="item.estado === 1" ><v-chip small style="background-color:green;color:white;">Activo</v-chip></span>
        <span v-if="item.estado === 0" ><v-chip small style="background-color:red;color:white;">Usado</v-chip></span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-menu
          bottom
          origin="center center"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab dark small
              color="#006699"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>menu</v-icon>
            </v-btn>
          </template>
          <v-list>
              <v-list-item @click="SetEditItem(item)"><v-icon color="#006699" small  >edit</v-icon>Editar</v-list-item>
              <v-list-item @click="setEliminar(item)"><v-icon color="red" small  >delete</v-icon>Eliminar</v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:no-data>
     <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->
     Clica em + para adicionar novo estudante
      </template>
    </v-data-table>
    </v-card>
  </div>
</div>
</div>
</template>
 <script>
 import axios from '../../plugins/axios'
 import utilitarios from '../../plugins/utilitarios'
 const ls = require('local-storage')
 export default {

    data: () => ({
      headers: [
      {
        text: 'Estudante',
        align: 'left',
        sortable: false,
        value: 'nome'
      },
      { text: 'Identificador', value: 'num_recibo' },
      { text: 'Banco', value: 'banco_' },
      { text: 'Nºconta', value: 'numeroConta' },
      { text: 'Valor', value: 'valor' },
      { text: 'Estado', value: 'estado' },
      { text: 'Criado', value: 'data_' },
      { text: 'Autor', value: 'autor' }
      ],
      utilitarios: utilitarios,
      dialog: false,
      overlay: false,
      isLoading: false,
      ruleRequired: [value => !!value || 'campo obrigatorio'],
      comprovativos:[],
      searchInDb:''
    }),

    created(){
       this.initialize()
    },

    methods: {
      openDialog (){
          this.dialog = true
      },

     async initialize() {
       try {
         this.isLoading = true
         this.comprovativos = await axios.get('ComprovativosFindAll').then(res => res.data)
       } catch (error) {
         this.isLoading = false
       }finally{this.isLoading = false}
        
      }
       
  }
  
 }
 </script>
 
<style scoped>
.bg {
 color:green;
 background: red
}

</style>
